import React from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import RestoreFromTrash from '@material-ui/icons/RestoreFromTrash';

const ReactivarConveniosButton = ({ idItem, reactivarPractica }) => {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Button
                style={{color:"red"}}
                size={"large"}
                startIcon={<RestoreFromTrash />}
                onClick={handleClickOpen}
            />
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Reactivación de práctica</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Una vez reactivada la práctica, se tomará la primera fecha disponible en caso de que haya cargadas valorizaciones futuras
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={() => {
                        reactivarPractica(idItem)
                        handleClose()
                    }} color="primary" autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ReactivarConveniosButton
